/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetAnswersDto
 */
export interface AssetAnswersDto {
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasDomesticRealEstate: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    domesticRealEstateDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasForeignRealEstate: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    foreignRealEstateDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasBuildingSavingsContracts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasSavingsAccounts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasLifeInsurances: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasPensionInsurances: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasSecuritiesDepots: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasSafeDeposit: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    safeDepositDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasOtherCashAssets: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    isSavedForProceeding: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetAnswersDto
     */
    savedForProceedingAmount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetAnswersDto
     */
    savedForProceedingDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    otherCashAssetsDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasValuables: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    valuablesDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasFurnishings: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    furnishingsDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasAppliances: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    appliancesDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasEquipment: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    equipmentDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasVehicles: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    vehiclesDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasBuildingsOnForeignLand: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    buildingsOnForeignLandDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasOtherItems: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    otherItemsDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    ownsAllItems: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    itemsOwnedByOthersDetails: string | null;
}

/**
 * Check if a given object implements the AssetAnswersDto interface.
 */
export function instanceOfAssetAnswersDto(value: object): value is AssetAnswersDto {
    if (!('hasDomesticRealEstate' in value) || value['hasDomesticRealEstate'] === undefined) return false;
    if (!('domesticRealEstateDetails' in value) || value['domesticRealEstateDetails'] === undefined) return false;
    if (!('hasForeignRealEstate' in value) || value['hasForeignRealEstate'] === undefined) return false;
    if (!('foreignRealEstateDetails' in value) || value['foreignRealEstateDetails'] === undefined) return false;
    if (!('hasBuildingSavingsContracts' in value) || value['hasBuildingSavingsContracts'] === undefined) return false;
    if (!('hasSavingsAccounts' in value) || value['hasSavingsAccounts'] === undefined) return false;
    if (!('hasLifeInsurances' in value) || value['hasLifeInsurances'] === undefined) return false;
    if (!('hasPensionInsurances' in value) || value['hasPensionInsurances'] === undefined) return false;
    if (!('hasSecuritiesDepots' in value) || value['hasSecuritiesDepots'] === undefined) return false;
    if (!('hasSafeDeposit' in value) || value['hasSafeDeposit'] === undefined) return false;
    if (!('safeDepositDetails' in value) || value['safeDepositDetails'] === undefined) return false;
    if (!('hasOtherCashAssets' in value) || value['hasOtherCashAssets'] === undefined) return false;
    if (!('isSavedForProceeding' in value) || value['isSavedForProceeding'] === undefined) return false;
    if (!('savedForProceedingAmount' in value) || value['savedForProceedingAmount'] === undefined) return false;
    if (!('savedForProceedingDate' in value) || value['savedForProceedingDate'] === undefined) return false;
    if (!('otherCashAssetsDetails' in value) || value['otherCashAssetsDetails'] === undefined) return false;
    if (!('hasValuables' in value) || value['hasValuables'] === undefined) return false;
    if (!('valuablesDetails' in value) || value['valuablesDetails'] === undefined) return false;
    if (!('hasFurnishings' in value) || value['hasFurnishings'] === undefined) return false;
    if (!('furnishingsDetails' in value) || value['furnishingsDetails'] === undefined) return false;
    if (!('hasAppliances' in value) || value['hasAppliances'] === undefined) return false;
    if (!('appliancesDetails' in value) || value['appliancesDetails'] === undefined) return false;
    if (!('hasEquipment' in value) || value['hasEquipment'] === undefined) return false;
    if (!('equipmentDetails' in value) || value['equipmentDetails'] === undefined) return false;
    if (!('hasVehicles' in value) || value['hasVehicles'] === undefined) return false;
    if (!('vehiclesDetails' in value) || value['vehiclesDetails'] === undefined) return false;
    if (!('hasBuildingsOnForeignLand' in value) || value['hasBuildingsOnForeignLand'] === undefined) return false;
    if (!('buildingsOnForeignLandDetails' in value) || value['buildingsOnForeignLandDetails'] === undefined) return false;
    if (!('hasOtherItems' in value) || value['hasOtherItems'] === undefined) return false;
    if (!('otherItemsDetails' in value) || value['otherItemsDetails'] === undefined) return false;
    if (!('ownsAllItems' in value) || value['ownsAllItems'] === undefined) return false;
    if (!('itemsOwnedByOthersDetails' in value) || value['itemsOwnedByOthersDetails'] === undefined) return false;
    return true;
}

export function AssetAnswersDtoFromJSON(json: any): AssetAnswersDto {
    return AssetAnswersDtoFromJSONTyped(json, false);
}

export function AssetAnswersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAnswersDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hasDomesticRealEstate': json['hasDomesticRealEstate'],
        'domesticRealEstateDetails': json['domesticRealEstateDetails'],
        'hasForeignRealEstate': json['hasForeignRealEstate'],
        'foreignRealEstateDetails': json['foreignRealEstateDetails'],
        'hasBuildingSavingsContracts': json['hasBuildingSavingsContracts'],
        'hasSavingsAccounts': json['hasSavingsAccounts'],
        'hasLifeInsurances': json['hasLifeInsurances'],
        'hasPensionInsurances': json['hasPensionInsurances'],
        'hasSecuritiesDepots': json['hasSecuritiesDepots'],
        'hasSafeDeposit': json['hasSafeDeposit'],
        'safeDepositDetails': json['safeDepositDetails'],
        'hasOtherCashAssets': json['hasOtherCashAssets'],
        'isSavedForProceeding': json['isSavedForProceeding'],
        'savedForProceedingAmount': json['savedForProceedingAmount'],
        'savedForProceedingDate': (json['savedForProceedingDate'] == null ? null : new Date(json['savedForProceedingDate'])),
        'otherCashAssetsDetails': json['otherCashAssetsDetails'],
        'hasValuables': json['hasValuables'],
        'valuablesDetails': json['valuablesDetails'],
        'hasFurnishings': json['hasFurnishings'],
        'furnishingsDetails': json['furnishingsDetails'],
        'hasAppliances': json['hasAppliances'],
        'appliancesDetails': json['appliancesDetails'],
        'hasEquipment': json['hasEquipment'],
        'equipmentDetails': json['equipmentDetails'],
        'hasVehicles': json['hasVehicles'],
        'vehiclesDetails': json['vehiclesDetails'],
        'hasBuildingsOnForeignLand': json['hasBuildingsOnForeignLand'],
        'buildingsOnForeignLandDetails': json['buildingsOnForeignLandDetails'],
        'hasOtherItems': json['hasOtherItems'],
        'otherItemsDetails': json['otherItemsDetails'],
        'ownsAllItems': json['ownsAllItems'],
        'itemsOwnedByOthersDetails': json['itemsOwnedByOthersDetails'],
    };
}

export function AssetAnswersDtoToJSON(json: any): AssetAnswersDto {
    return AssetAnswersDtoToJSONTyped(json, false);
}

export function AssetAnswersDtoToJSONTyped(value?: AssetAnswersDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasDomesticRealEstate': value['hasDomesticRealEstate'],
        'domesticRealEstateDetails': value['domesticRealEstateDetails'],
        'hasForeignRealEstate': value['hasForeignRealEstate'],
        'foreignRealEstateDetails': value['foreignRealEstateDetails'],
        'hasBuildingSavingsContracts': value['hasBuildingSavingsContracts'],
        'hasSavingsAccounts': value['hasSavingsAccounts'],
        'hasLifeInsurances': value['hasLifeInsurances'],
        'hasPensionInsurances': value['hasPensionInsurances'],
        'hasSecuritiesDepots': value['hasSecuritiesDepots'],
        'hasSafeDeposit': value['hasSafeDeposit'],
        'safeDepositDetails': value['safeDepositDetails'],
        'hasOtherCashAssets': value['hasOtherCashAssets'],
        'isSavedForProceeding': value['isSavedForProceeding'],
        'savedForProceedingAmount': value['savedForProceedingAmount'],
        'savedForProceedingDate': value['savedForProceedingDate'] == null ? value['savedForProceedingDate'] : `${value['savedForProceedingDate'].getFullYear()}-${String(value['savedForProceedingDate'].getMonth()+1).padStart(2,'0')}-${String(value['savedForProceedingDate'].getDate()).padStart(2,'0')}`,
        'otherCashAssetsDetails': value['otherCashAssetsDetails'],
        'hasValuables': value['hasValuables'],
        'valuablesDetails': value['valuablesDetails'],
        'hasFurnishings': value['hasFurnishings'],
        'furnishingsDetails': value['furnishingsDetails'],
        'hasAppliances': value['hasAppliances'],
        'appliancesDetails': value['appliancesDetails'],
        'hasEquipment': value['hasEquipment'],
        'equipmentDetails': value['equipmentDetails'],
        'hasVehicles': value['hasVehicles'],
        'vehiclesDetails': value['vehiclesDetails'],
        'hasBuildingsOnForeignLand': value['hasBuildingsOnForeignLand'],
        'buildingsOnForeignLandDetails': value['buildingsOnForeignLandDetails'],
        'hasOtherItems': value['hasOtherItems'],
        'otherItemsDetails': value['otherItemsDetails'],
        'ownsAllItems': value['ownsAllItems'],
        'itemsOwnedByOthersDetails': value['itemsOwnedByOthersDetails'],
    };
}

